import { createGenericStore } from './utils/genericStore.js'
import axios from 'axios'

// 1. Define custom options for Notifications
const notificationOptions = {
  state: () => ({
    unreadCount: 0,
  }),

  actions: {
    // Fetch just the number (for the bell badge)
    async fetchUnreadCount() {
      try {
        const response = await axios.get('/api/v1/notifications/unread-count');
        this.unreadCount = response.data.count;
      } catch (error) {
        console.error('Failed to fetch unread count', error);
      }
    },

    // Mark single as read with Optimistic Update
    async markAsRead(id) {
      // 1. Find item in the generic store's list
      // (Assuming your generic store names the array 'items' or 'data')
      const item = this.items?.find(n => n.id === id) || this.data?.find(n => n.id === id);

      // 2. Optimistic update: Update local state immediately
      if (item && !item.read_at) {
        item.read_at = new Date().toISOString();
        this.unreadCount = Math.max(0, this.unreadCount - 1);
      }

      // 3. Send request to server
      try {
        await axios.post(`/api/v1/notifications/${id}/read`);
      } catch (error) {
        console.error('Failed to mark as read', error);
        // Optional: Revert state if it fails
      }
    },

    // Mark all as read
    async markAllAsRead() {
      // 1. Optimistic update: Mark all loaded items as read
      const list = this.items || this.data || [];
      list.forEach(n => {
        if(!n.read_at) n.read_at = new Date().toISOString();
      });

      this.unreadCount = 0;

      // 2. Send request
      try {
        await axios.post('/api/v1/notifications/read-all');
        await this.fetchItems(); // Refresh the list
      } catch (error) {
        console.error('Failed to mark all read', error);
      }
    },

    // New action to handle incoming Reverb event
    handleRealtimeNotification(payload) {
      // 1. Increment the badge count
      this.unreadCount++;

      // 2. Add to the list (only if we have initialized the list)
      // We use 'unshift' to put it at the very top
      if (this.items) {
        this.items.unshift(payload);
      }

      // 3. Optional: Play a sound
      // new Audio('/sounds/notification.mp3').play();
    }
  }
}

// 2. Create the store hook
// We point it to '/api/notifications' so the generic fetch logic handles pagination
export const useNotificationStore = createGenericStore(
  'notifications',
  '/api/v1/notifications',
  notificationOptions
)
